// NetSuite price-level options used by Pay-Code rules + holiday overrides.
export const PRICE_LEVELS = ['STRAIGHT TIME', 'OVERTIME', 'HOLIDAY', 'PREMIUM', 'VACATION', 'EACH'];
